import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

export const PAYEE_OVERVIEW_TABS_VALUES_DIGITAL_WALLET_TRANSACTIONS = "digital_wallet_transactions";
export const PAYEE_OVERVIEW_TABS_VALUES_PARK_TRANSACTIONS = "park_transactions";

export const PAYEE_OVERVIEW_TABS_VALUES_INVOICES = "invoices";

export const PAYEE_OVERVIEW_TABS_VALUES_CITATIONS = "citations";

export type PayeeOverviewTabValue = "digital_wallet_transactions" | "park_transactions" | "invoices" | "citations";

export const PAYEE_OVERVIEW_TABS_LABELS = {
  [PAYEE_OVERVIEW_TABS_VALUES_DIGITAL_WALLET_TRANSACTIONS]: "Digital Wallet Transactions",
  [PAYEE_OVERVIEW_TABS_VALUES_PARK_TRANSACTIONS]: "Park Transactions",
  [PAYEE_OVERVIEW_TABS_VALUES_INVOICES]: "Invoices",
  [PAYEE_OVERVIEW_TABS_VALUES_CITATIONS]: "Citation Transactions",
};

export interface PayeeOverviewTabButtonProps {
  active: boolean;
  onClick: () => void;
  label: string;
  loading?: boolean;
}

export const PayeeOverviewTabDesktopButton: React.FC<PayeeOverviewTabButtonProps> = ({
  active,
  onClick,
  label,
  loading = false,
}) => {
  return loading ? (
    <Skeleton>
      <Box width="240px" height="45px" />
    </Skeleton>
  ) : (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        color: active ? "primary.main" : "text.secondary",
        textTransform: "none",
        width: "342px",
        borderBottom: active ? "1px solid" : "none",
        borderBottomColor: active ? "primary.main" : "none",
        borderRadius: "0px",
      }}
    >
      <Typography variant="body3" fontWeight={500}>
        {label}
      </Typography>
    </Button>
  );
};

export const PayeeOverviewTabs: React.FC<PayeeOverviewTabsProps> = ({ loading = false, tab, tabs, onChangeTab }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        borderBottom: loading ? "none" : "1px solid",
        borderBottomColor: loading ? "none" : "action.disabledBackground",
      }}
    >
      <Stack direction={"row"} spacing={loading ? 16 : 0}>
        {tabs?.map(({ value, label }) => (
          <PayeeOverviewTabDesktopButton
            key={value}
            active={tab === value}
            onClick={() => onChangeTab(value)}
            label={label}
            loading={loading}
          />
        ))}
      </Stack>
    </Box>
  );
};

export interface PayeeOverviewTabsProps {
  loading?: boolean;
  tab: PayeeOverviewTabValue;
  tabs?: { value: PayeeOverviewTabValue; label: string }[];
  onChangeTab: (tab: PayeeOverviewTabValue) => void;
}

export default PayeeOverviewTabs;
